import { useModalDismiss } from '../../../hooks/useModalDismiss';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationTriangle, faSync } from '@fortawesome/free-solid-svg-icons';

const RejectionModal = ({ show, onClose, onConfirm, isSubmitting }) => {
  const [remarks, setRemarks] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!remarks.trim()) {
      setError('Veuillez fournir des remarques pour expliquer le rejet.');
      return;
    }

    setError('');
    onConfirm(remarks.trim());
  };

  const handleClose = () => {
    setRemarks('');
    setError('');
    onClose();
  };

  // No backdrop handler here by design; the hook adds only the Escape route out.
  const dismiss = useModalDismiss(onClose, { backdropClose: false, enabled: show });

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" {...dismiss}>
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">Rejeter le quota</h3>
          </div>
          <button
            onClick={handleClose}
            disabled={isSubmitting}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="p-4">
            <p className="text-gray-700 mb-4">
              Vous êtes sur le point de rejeter ce quota. Veuillez fournir des remarques pour expliquer les raisons du rejet.
            </p>

            <div className="mb-4">
              <label htmlFor="remarks" className="block text-sm font-medium text-gray-700 mb-2">
                Remarques <span className="text-red-600">*</span>
              </label>
              <textarea
                id="remarks"
                value={remarks}
                onChange={(e) => {
                  setRemarks(e.target.value);
                  setError('');
                }}
                rows={5}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
                placeholder="Expliquez les raisons du rejet et les modifications nécessaires..."
                disabled={isSubmitting}
                required
              />
              {error && (
                <p className="mt-1 text-sm text-red-600">{error}</p>
              )}
            </div>
          </div>

          <div className="flex items-center justify-end gap-3 p-4 border-t border-gray-200 bg-gray-50">
            <button
              type="button"
              onClick={handleClose}
              disabled={isSubmitting}
              className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isSubmitting || !remarks.trim()}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isSubmitting ? (
                <>
                  <FontAwesomeIcon icon={faSync} className="animate-spin" />
                  <span>Rejet en cours...</span>
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faExclamationTriangle} />
                  <span>Rejeter</span>
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RejectionModal;
